import { Paper, Stack, Typography, Box } from '@mui/material'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { t } from '@lingui/macro'
import { useFormContext, useWatch } from 'react-hook-form'
import { MergePatientsFormData } from '../model/useMergePatientsForm'

type SelectionMap = Record<string, 'primary' | 'secondary'>

type FieldChoiceToggleProps = {
  fieldKey: string
  label: string
  primaryValue: string | Date
  secondaryValue: string | Date
}

export function FieldChoiceToggle({ fieldKey, label, primaryValue, secondaryValue }: FieldChoiceToggleProps) {
  const rhForm = useFormContext<MergePatientsFormData>()
  const selected = useWatch({ control: rhForm.control, name: `fields.${fieldKey}` })
  return (
    <Paper key={fieldKey} variant="outlined" sx={{ p: 2, bgcolor: 'warning.lighter' }}>
      <Stack spacing={1}>
        <Typography variant="subtitle2" color="text.secondary">
          {label}
        </Typography>
        <ToggleButtonGroup
          value={selected || 'primary'}
          exclusive
          // onChange={(e, val) => val && setSelection({ ...selection, [fieldKey]: val })}
          onChange={(_event, val) => {
            rhForm.setValue(`fields.${fieldKey}`, val)
          }}
          fullWidth
          size="small"
        >
          <ButtonChoiceToggle value="primary" selected={selected === 'primary'} text={primaryValue} label={t`Primary`} />
          <ButtonChoiceToggle value="secondary" selected={selected === 'secondary'} text={secondaryValue} label={t`Secondary`} />
        </ToggleButtonGroup>
      </Stack>
    </Paper>
  )
}

type ButtonChoiceToggleProps = {
  value: 'primary' | 'secondary'
  selected: boolean
  text: string | Date
  label: string
}

function ButtonChoiceToggle({ value, selected, text, label }: ButtonChoiceToggleProps) {
  if (!text) return null

  return (
    <ToggleButton value={value}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ textAlign: 'left', width: '100%' }}>
        <CheckCircleIcon fontSize="small" color={selected ? 'primary' : 'disabled'} />
        <Box sx={{ flex: 1, overflow: 'hidden' }}>
          <Typography variant="caption" display="block" color="text.secondary">
            {label}
          </Typography>
          <Typography variant="body2" noWrap>
            {text}
          </Typography>
        </Box>
      </Stack>
    </ToggleButton>
  )
}
